/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var RequestShortener = require("./RequestShortener");

var SizeFormatHelpers = require("./SizeFormatHelpers");

var formatLocation = require("./formatLocation");

var identifierUtils = require("./util/identifier");

var compareLocations = require("./compareLocations");

var _require = require("./logging/Logger"),
    LogType = _require.LogType;

var optionsOrFallback = function optionsOrFallback() {
  var optionValues = [];
  optionValues.push.apply(optionValues, arguments);
  return optionValues.find(function (optionValue) {
    return optionValue !== undefined;
  });
};

var compareId = function compareId(a, b) {
  if (_typeof(a) !== _typeof(b)) {
    return _typeof(a) < _typeof(b) ? -1 : 1;
  }

  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
};

var Stats = /*#__PURE__*/function () {
  function Stats(compilation) {
    _classCallCheck(this, Stats);

    this.compilation = compilation;
    this.hash = compilation.hash;
    this.startTime = undefined;
    this.endTime = undefined;
  }

  _createClass(Stats, [{
    key: "formatFilePath",
    value: function formatFilePath(filePath) {
      var OPTIONS_REGEXP = /^(\s|\S)*!/;
      return filePath.includes("!") ? "".concat(filePath.replace(OPTIONS_REGEXP, ""), " (").concat(filePath, ")") : "".concat(filePath);
    }
  }, {
    key: "hasWarnings",
    value: function hasWarnings() {
      return this.compilation.warnings.length > 0 || this.compilation.children.some(function (child) {
        return child.getStats().hasWarnings();
      });
    }
  }, {
    key: "hasErrors",
    value: function hasErrors() {
      return this.compilation.errors.length > 0 || this.compilation.children.some(function (child) {
        return child.getStats().hasErrors();
      });
    } // remove a prefixed "!" that can be specified to reverse sort order

  }, {
    key: "normalizeFieldKey",
    value: function normalizeFieldKey(field) {
      if (field[0] === "!") {
        return field.substr(1);
      }

      return field;
    } // if a field is prefixed by a "!" reverse sort order

  }, {
    key: "sortOrderRegular",
    value: function sortOrderRegular(field) {
      if (field[0] === "!") {
        return false;
      }

      return true;
    }
  }, {
    key: "toJson",
    value: function toJson(options, forToString) {
      var _this = this;

      if (typeof options === "boolean" || typeof options === "string") {
        options = Stats.presetToOptions(options);
      } else if (!options) {
        options = {};
      }

      var optionOrLocalFallback = function optionOrLocalFallback(v, def) {
        return v !== undefined ? v : options.all !== undefined ? options.all : def;
      };

      var testAgainstGivenOption = function testAgainstGivenOption(item) {
        if (typeof item === "string") {
          var regExp = new RegExp("[\\\\/]".concat(item.replace( // eslint-disable-next-line no-useless-escape
          /[-[\]{}()*+?.\\^$|]/g, "\\$&"), "([\\\\/]|$|!|\\?)"));
          return function (ident) {
            return regExp.test(ident);
          };
        }

        if (item && _typeof(item) === "object" && typeof item.test === "function") {
          return function (ident) {
            return item.test(ident);
          };
        }

        if (typeof item === "function") {
          return item;
        }

        if (typeof item === "boolean") {
          return function () {
            return item;
          };
        }
      };

      var compilation = this.compilation;
      var context = optionsOrFallback(options.context, compilation.compiler.context);
      var requestShortener = compilation.compiler.context === context ? compilation.requestShortener : new RequestShortener(context);
      var showPerformance = optionOrLocalFallback(options.performance, true);
      var showHash = optionOrLocalFallback(options.hash, true);
      var showEnv = optionOrLocalFallback(options.env, false);
      var showVersion = optionOrLocalFallback(options.version, true);
      var showTimings = optionOrLocalFallback(options.timings, true);
      var showBuiltAt = optionOrLocalFallback(options.builtAt, true);
      var showAssets = optionOrLocalFallback(options.assets, true);
      var showEntrypoints = optionOrLocalFallback(options.entrypoints, true);
      var showChunkGroups = optionOrLocalFallback(options.chunkGroups, !forToString);
      var showChunks = optionOrLocalFallback(options.chunks, !forToString);
      var showChunkModules = optionOrLocalFallback(options.chunkModules, true);
      var showChunkOrigins = optionOrLocalFallback(options.chunkOrigins, !forToString);
      var showModules = optionOrLocalFallback(options.modules, true);
      var showNestedModules = optionOrLocalFallback(options.nestedModules, true);
      var showModuleAssets = optionOrLocalFallback(options.moduleAssets, !forToString);
      var showDepth = optionOrLocalFallback(options.depth, !forToString);
      var showCachedModules = optionOrLocalFallback(options.cached, true);
      var showCachedAssets = optionOrLocalFallback(options.cachedAssets, true);
      var showReasons = optionOrLocalFallback(options.reasons, !forToString);
      var showUsedExports = optionOrLocalFallback(options.usedExports, !forToString);
      var showProvidedExports = optionOrLocalFallback(options.providedExports, !forToString);
      var showOptimizationBailout = optionOrLocalFallback(options.optimizationBailout, !forToString);
      var showChildren = optionOrLocalFallback(options.children, true);
      var showSource = optionOrLocalFallback(options.source, !forToString);
      var showModuleTrace = optionOrLocalFallback(options.moduleTrace, true);
      var showErrors = optionOrLocalFallback(options.errors, true);
      var showErrorDetails = optionOrLocalFallback(options.errorDetails, !forToString);
      var showWarnings = optionOrLocalFallback(options.warnings, true);
      var warningsFilter = optionsOrFallback(options.warningsFilter, null);
      var showPublicPath = optionOrLocalFallback(options.publicPath, !forToString);
      var showLogging = optionOrLocalFallback(options.logging, forToString ? "info" : true);
      var showLoggingTrace = optionOrLocalFallback(options.loggingTrace, !forToString);
      var loggingDebug = [].concat(optionsOrFallback(options.loggingDebug, [])).map(testAgainstGivenOption);
      var excludeModules = [].concat(optionsOrFallback(options.excludeModules, options.exclude, [])).map(testAgainstGivenOption);
      var excludeAssets = [].concat(optionsOrFallback(options.excludeAssets, [])).map(testAgainstGivenOption);
      var maxModules = optionsOrFallback(options.maxModules, forToString ? 15 : Infinity);
      var sortModules = optionsOrFallback(options.modulesSort, "id");
      var sortChunks = optionsOrFallback(options.chunksSort, "id");
      var sortAssets = optionsOrFallback(options.assetsSort, "");
      var showOutputPath = optionOrLocalFallback(options.outputPath, !forToString);

      if (!showCachedModules) {
        excludeModules.push(function (ident, module) {
          return !module.built;
        });
      }

      var createModuleFilter = function createModuleFilter() {
        var i = 0;
        return function (module) {
          if (excludeModules.length > 0) {
            var ident = requestShortener.shorten(module.resource);
            var excluded = excludeModules.some(function (fn) {
              return fn(ident, module);
            });
            if (excluded) return false;
          }

          var result = i < maxModules;
          i++;
          return result;
        };
      };

      var createAssetFilter = function createAssetFilter() {
        return function (asset) {
          if (excludeAssets.length > 0) {
            var ident = asset.name;
            var excluded = excludeAssets.some(function (fn) {
              return fn(ident, asset);
            });
            if (excluded) return false;
          }

          return showCachedAssets || asset.emitted;
        };
      };

      var sortByFieldAndOrder = function sortByFieldAndOrder(fieldKey, a, b) {
        if (a[fieldKey] === null && b[fieldKey] === null) return 0;
        if (a[fieldKey] === null) return 1;
        if (b[fieldKey] === null) return -1;
        if (a[fieldKey] === b[fieldKey]) return 0;
        if (_typeof(a[fieldKey]) !== _typeof(b[fieldKey])) return _typeof(a[fieldKey]) < _typeof(b[fieldKey]) ? -1 : 1;
        return a[fieldKey] < b[fieldKey] ? -1 : 1;
      };

      var sortByField = function sortByField(field, originalArray) {
        var originalMap = originalArray.reduce(function (map, v, i) {
          map.set(v, i);
          return map;
        }, new Map());
        return function (a, b) {
          if (field) {
            var fieldKey = _this.normalizeFieldKey(field); // if a field is prefixed with a "!" the sort is reversed!


            var sortIsRegular = _this.sortOrderRegular(field);

            var cmp = sortByFieldAndOrder(fieldKey, sortIsRegular ? a : b, sortIsRegular ? b : a);
            if (cmp) return cmp;
          }

          return originalMap.get(a) - originalMap.get(b);
        };
      };

      var formatError = function formatError(e) {
        var text = "";

        if (typeof e === "string") {
          e = {
            message: e
          };
        }

        if (e.chunk) {
          text += "chunk ".concat(e.chunk.name || e.chunk.id).concat(e.chunk.hasRuntime() ? " [entry]" : e.chunk.canBeInitial() ? " [initial]" : "", "\n");
        }

        if (e.file) {
          text += "".concat(e.file, "\n");
        }

        if (e.module && e.module.readableIdentifier && typeof e.module.readableIdentifier === "function") {
          text += _this.formatFilePath(e.module.readableIdentifier(requestShortener));

          if (_typeof(e.loc) === "object") {
            var locInfo = formatLocation(e.loc);
            if (locInfo) text += " ".concat(locInfo);
          }

          text += "\n";
        }

        text += e.message;

        if (showErrorDetails && e.details) {
          text += "\n".concat(e.details);
        }

        if (showErrorDetails && e.missing) {
          text += e.missing.map(function (item) {
            return "\n[".concat(item, "]");
          }).join("");
        }

        if (showModuleTrace && e.origin) {
          text += "\n @ ".concat(_this.formatFilePath(e.origin.readableIdentifier(requestShortener)));

          if (_typeof(e.originLoc) === "object") {
            var _locInfo = formatLocation(e.originLoc);

            if (_locInfo) text += " ".concat(_locInfo);
          }

          if (e.dependencies) {
            var _iterator = _createForOfIteratorHelper(e.dependencies),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var dep = _step.value;
                if (!dep.loc) continue;
                if (typeof dep.loc === "string") continue;

                var _locInfo2 = formatLocation(dep.loc);

                if (!_locInfo2) continue;
                text += " ".concat(_locInfo2);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          var current = e.origin;

          while (current.issuer) {
            current = current.issuer;
            text += "\n @ ".concat(current.readableIdentifier(requestShortener));
          }
        }

        return text;
      };

      var obj = {
        errors: compilation.errors.map(formatError),
        warnings: Stats.filterWarnings(compilation.warnings.map(formatError), warningsFilter)
      }; //We just hint other renderers since actually omitting
      //errors/warnings from the JSON would be kind of weird.

      Object.defineProperty(obj, "_showWarnings", {
        value: showWarnings,
        enumerable: false
      });
      Object.defineProperty(obj, "_showErrors", {
        value: showErrors,
        enumerable: false
      });

      if (showVersion) {
        obj.version = require("../package.json").version;
      }

      if (showHash) obj.hash = this.hash;

      if (showTimings && this.startTime && this.endTime) {
        obj.time = this.endTime - this.startTime;
      }

      if (showBuiltAt && this.endTime) {
        obj.builtAt = this.endTime;
      }

      if (showEnv && options._env) {
        obj.env = options._env;
      }

      if (compilation.needAdditionalPass) {
        obj.needAdditionalPass = true;
      }

      if (showPublicPath) {
        obj.publicPath = this.compilation.mainTemplate.getPublicPath({
          hash: this.compilation.hash
        });
      }

      if (showOutputPath) {
        obj.outputPath = this.compilation.mainTemplate.outputOptions.path;
      }

      if (showAssets) {
        var assetsByFile = {};
        var compilationAssets = compilation.getAssets().sort(function (a, b) {
          return a.name < b.name ? -1 : 1;
        });
        obj.assetsByChunkName = {};
        obj.assets = compilationAssets.map(function (_ref) {
          var name = _ref.name,
              source = _ref.source,
              info = _ref.info;
          var obj = {
            name: name,
            size: source.size(),
            chunks: [],
            chunkNames: [],
            info: info,
            // TODO webpack 5: remove .emitted
            emitted: source.emitted || compilation.emittedAssets.has(name)
          };

          if (showPerformance) {
            obj.isOverSizeLimit = source.isOverSizeLimit;
          }

          assetsByFile[name] = obj;
          return obj;
        }).filter(createAssetFilter());
        obj.filteredAssets = compilationAssets.length - obj.assets.length;

        var _iterator2 = _createForOfIteratorHelper(compilation.chunks),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var chunk = _step2.value;

            var _iterator3 = _createForOfIteratorHelper(chunk.files),
                _step3;

            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var asset = _step3.value;

                if (assetsByFile[asset]) {
                  var _iterator4 = _createForOfIteratorHelper(chunk.ids),
                      _step4;

                  try {
                    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                      var id = _step4.value;
                      assetsByFile[asset].chunks.push(id);
                    }
                  } catch (err) {
                    _iterator4.e(err);
                  } finally {
                    _iterator4.f();
                  }

                  if (chunk.name) {
                    assetsByFile[asset].chunkNames.push(chunk.name);

                    if (obj.assetsByChunkName[chunk.name]) {
                      obj.assetsByChunkName[chunk.name] = [].concat(obj.assetsByChunkName[chunk.name]).concat([asset]);
                    } else {
                      obj.assetsByChunkName[chunk.name] = asset;
                    }
                  }
                }
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        obj.assets.sort(sortByField(sortAssets, obj.assets));
      }

      var fnChunkGroup = function fnChunkGroup(groupMap) {
        var obj = {};

        var _iterator5 = _createForOfIteratorHelper(groupMap),
            _step5;

        try {
          var _loop = function _loop() {
            var keyValuePair = _step5.value;
            var name = keyValuePair[0];
            var cg = keyValuePair[1];
            var children = cg.getChildrenByOrders();
            obj[name] = {
              chunks: cg.chunks.map(function (c) {
                return c.id;
              }),
              assets: cg.chunks.reduce(function (array, c) {
                return array.concat(c.files || []);
              }, []),
              children: Object.keys(children).reduce(function (obj, key) {
                var groups = children[key];
                obj[key] = groups.map(function (group) {
                  return {
                    name: group.name,
                    chunks: group.chunks.map(function (c) {
                      return c.id;
                    }),
                    assets: group.chunks.reduce(function (array, c) {
                      return array.concat(c.files || []);
                    }, [])
                  };
                });
                return obj;
              }, Object.create(null)),
              childAssets: Object.keys(children).reduce(function (obj, key) {
                var groups = children[key];
                obj[key] = Array.from(groups.reduce(function (set, group) {
                  var _iterator6 = _createForOfIteratorHelper(group.chunks),
                      _step6;

                  try {
                    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                      var _chunk = _step6.value;

                      var _iterator7 = _createForOfIteratorHelper(_chunk.files),
                          _step7;

                      try {
                        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                          var _asset = _step7.value;
                          set.add(_asset);
                        }
                      } catch (err) {
                        _iterator7.e(err);
                      } finally {
                        _iterator7.f();
                      }
                    }
                  } catch (err) {
                    _iterator6.e(err);
                  } finally {
                    _iterator6.f();
                  }

                  return set;
                }, new Set()));
                return obj;
              }, Object.create(null))
            };

            if (showPerformance) {
              obj[name].isOverSizeLimit = cg.isOverSizeLimit;
            }
          };

          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            _loop();
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        return obj;
      };

      if (showEntrypoints) {
        obj.entrypoints = fnChunkGroup(compilation.entrypoints);
      }

      if (showChunkGroups) {
        obj.namedChunkGroups = fnChunkGroup(compilation.namedChunkGroups);
      }

      var fnModule = function fnModule(module) {
        var path = [];
        var current = module;

        while (current.issuer) {
          path.push(current = current.issuer);
        }

        path.reverse();
        var obj = {
          id: module.id,
          identifier: module.identifier(),
          name: module.readableIdentifier(requestShortener),
          index: module.index,
          index2: module.index2,
          size: module.size(),
          cacheable: module.buildInfo.cacheable,
          built: !!module.built,
          optional: module.optional,
          prefetched: module.prefetched,
          chunks: Array.from(module.chunksIterable, function (chunk) {
            return chunk.id;
          }),
          issuer: module.issuer && module.issuer.identifier(),
          issuerId: module.issuer && module.issuer.id,
          issuerName: module.issuer && module.issuer.readableIdentifier(requestShortener),
          issuerPath: module.issuer && path.map(function (module) {
            return {
              id: module.id,
              identifier: module.identifier(),
              name: module.readableIdentifier(requestShortener),
              profile: module.profile
            };
          }),
          profile: module.profile,
          failed: !!module.error,
          errors: module.errors ? module.errors.length : 0,
          warnings: module.warnings ? module.warnings.length : 0
        };

        if (showModuleAssets) {
          obj.assets = Object.keys(module.buildInfo.assets || {});
        }

        if (showReasons) {
          obj.reasons = module.reasons.sort(function (a, b) {
            if (a.module && !b.module) return -1;
            if (!a.module && b.module) return 1;

            if (a.module && b.module) {
              var cmp = compareId(a.module.id, b.module.id);
              if (cmp) return cmp;
            }

            if (a.dependency && !b.dependency) return -1;
            if (!a.dependency && b.dependency) return 1;

            if (a.dependency && b.dependency) {
              var _cmp = compareLocations(a.dependency.loc, b.dependency.loc);

              if (_cmp) return _cmp;
              if (a.dependency.type < b.dependency.type) return -1;
              if (a.dependency.type > b.dependency.type) return 1;
            }

            return 0;
          }).map(function (reason) {
            var obj = {
              moduleId: reason.module ? reason.module.id : null,
              moduleIdentifier: reason.module ? reason.module.identifier() : null,
              module: reason.module ? reason.module.readableIdentifier(requestShortener) : null,
              moduleName: reason.module ? reason.module.readableIdentifier(requestShortener) : null,
              type: reason.dependency ? reason.dependency.type : null,
              explanation: reason.explanation,
              userRequest: reason.dependency ? reason.dependency.userRequest : null
            };

            if (reason.dependency) {
              var locInfo = formatLocation(reason.dependency.loc);

              if (locInfo) {
                obj.loc = locInfo;
              }
            }

            return obj;
          });
        }

        if (showUsedExports) {
          if (module.used === true) {
            obj.usedExports = module.usedExports;
          } else if (module.used === false) {
            obj.usedExports = false;
          }
        }

        if (showProvidedExports) {
          obj.providedExports = Array.isArray(module.buildMeta.providedExports) ? module.buildMeta.providedExports : null;
        }

        if (showOptimizationBailout) {
          obj.optimizationBailout = module.optimizationBailout.map(function (item) {
            if (typeof item === "function") return item(requestShortener);
            return item;
          });
        }

        if (showDepth) {
          obj.depth = module.depth;
        }

        if (showNestedModules) {
          if (module.modules) {
            var modules = module.modules;
            obj.modules = modules.sort(sortByField("depth", modules)).filter(createModuleFilter()).map(fnModule);
            obj.filteredModules = modules.length - obj.modules.length;
            obj.modules.sort(sortByField(sortModules, obj.modules));
          }
        }

        if (showSource && module._source) {
          obj.source = module._source.source();
        }

        return obj;
      };

      if (showChunks) {
        obj.chunks = compilation.chunks.map(function (chunk) {
          var parents = new Set();
          var children = new Set();
          var siblings = new Set();
          var childIdByOrder = chunk.getChildIdsByOrders();

          var _iterator8 = _createForOfIteratorHelper(chunk.groupsIterable),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var chunkGroup = _step8.value;

              var _iterator9 = _createForOfIteratorHelper(chunkGroup.parentsIterable),
                  _step9;

              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var parentGroup = _step9.value;

                  var _iterator12 = _createForOfIteratorHelper(parentGroup.chunks),
                      _step12;

                  try {
                    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                      var _chunk2 = _step12.value;
                      parents.add(_chunk2.id);
                    }
                  } catch (err) {
                    _iterator12.e(err);
                  } finally {
                    _iterator12.f();
                  }
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }

              var _iterator10 = _createForOfIteratorHelper(chunkGroup.childrenIterable),
                  _step10;

              try {
                for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                  var childGroup = _step10.value;

                  var _iterator13 = _createForOfIteratorHelper(childGroup.chunks),
                      _step13;

                  try {
                    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
                      var _chunk3 = _step13.value;
                      children.add(_chunk3.id);
                    }
                  } catch (err) {
                    _iterator13.e(err);
                  } finally {
                    _iterator13.f();
                  }
                }
              } catch (err) {
                _iterator10.e(err);
              } finally {
                _iterator10.f();
              }

              var _iterator11 = _createForOfIteratorHelper(chunkGroup.chunks),
                  _step11;

              try {
                for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                  var sibling = _step11.value;
                  if (sibling !== chunk) siblings.add(sibling.id);
                }
              } catch (err) {
                _iterator11.e(err);
              } finally {
                _iterator11.f();
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          var obj = {
            id: chunk.id,
            rendered: chunk.rendered,
            initial: chunk.canBeInitial(),
            entry: chunk.hasRuntime(),
            recorded: chunk.recorded,
            reason: chunk.chunkReason,
            size: chunk.modulesSize(),
            names: chunk.name ? [chunk.name] : [],
            files: chunk.files.slice(),
            hash: chunk.renderedHash,
            siblings: Array.from(siblings).sort(compareId),
            parents: Array.from(parents).sort(compareId),
            children: Array.from(children).sort(compareId),
            childrenByOrder: childIdByOrder
          };

          if (showChunkModules) {
            var modules = chunk.getModules();
            obj.modules = modules.slice().sort(sortByField("depth", modules)).filter(createModuleFilter()).map(fnModule);
            obj.filteredModules = chunk.getNumberOfModules() - obj.modules.length;
            obj.modules.sort(sortByField(sortModules, obj.modules));
          }

          if (showChunkOrigins) {
            obj.origins = Array.from(chunk.groupsIterable, function (g) {
              return g.origins;
            }).reduce(function (a, b) {
              return a.concat(b);
            }, []).map(function (origin) {
              return {
                moduleId: origin.module ? origin.module.id : undefined,
                module: origin.module ? origin.module.identifier() : "",
                moduleIdentifier: origin.module ? origin.module.identifier() : "",
                moduleName: origin.module ? origin.module.readableIdentifier(requestShortener) : "",
                loc: formatLocation(origin.loc),
                request: origin.request,
                reasons: origin.reasons || []
              };
            }).sort(function (a, b) {
              var cmp1 = compareId(a.moduleId, b.moduleId);
              if (cmp1) return cmp1;
              var cmp2 = compareId(a.loc, b.loc);
              if (cmp2) return cmp2;
              var cmp3 = compareId(a.request, b.request);
              if (cmp3) return cmp3;
              return 0;
            });
          }

          return obj;
        });
        obj.chunks.sort(sortByField(sortChunks, obj.chunks));
      }

      if (showModules) {
        obj.modules = compilation.modules.slice().sort(sortByField("depth", compilation.modules)).filter(createModuleFilter()).map(fnModule);
        obj.filteredModules = compilation.modules.length - obj.modules.length;
        obj.modules.sort(sortByField(sortModules, obj.modules));
      }

      if (showLogging) {
        (function () {
          var util = require("util");

          obj.logging = {};
          var acceptedTypes;
          var collapsedGroups = false;

          switch (showLogging) {
            case "none":
              acceptedTypes = new Set([]);
              break;

            case "error":
              acceptedTypes = new Set([LogType.error]);
              break;

            case "warn":
              acceptedTypes = new Set([LogType.error, LogType.warn]);
              break;

            case "info":
              acceptedTypes = new Set([LogType.error, LogType.warn, LogType.info]);
              break;

            case true:
            case "log":
              acceptedTypes = new Set([LogType.error, LogType.warn, LogType.info, LogType.log, LogType.group, LogType.groupEnd, LogType.groupCollapsed, LogType.clear]);
              break;

            case "verbose":
              acceptedTypes = new Set([LogType.error, LogType.warn, LogType.info, LogType.log, LogType.group, LogType.groupEnd, LogType.groupCollapsed, LogType.profile, LogType.profileEnd, LogType.time, LogType.status, LogType.clear]);
              collapsedGroups = true;
              break;
          }

          var _iterator14 = _createForOfIteratorHelper(compilation.logging),
              _step14;

          try {
            var _loop2 = function _loop2() {
              var _ref2 = _step14.value;
              _ref3 = _slicedToArray(_ref2, 2);
              var origin = _ref3[0];
              var logEntries = _ref3[1];
              var debugMode = loggingDebug.some(function (fn) {
                return fn(origin);
              });
              var collapseCounter = 0;
              var processedLogEntries = logEntries;

              if (!debugMode) {
                processedLogEntries = processedLogEntries.filter(function (entry) {
                  if (!acceptedTypes.has(entry.type)) return false;

                  if (!collapsedGroups) {
                    switch (entry.type) {
                      case LogType.groupCollapsed:
                        collapseCounter++;
                        return collapseCounter === 1;

                      case LogType.group:
                        if (collapseCounter > 0) collapseCounter++;
                        return collapseCounter === 0;

                      case LogType.groupEnd:
                        if (collapseCounter > 0) {
                          collapseCounter--;
                          return false;
                        }

                        return true;

                      default:
                        return collapseCounter === 0;
                    }
                  }

                  return true;
                });
              }

              processedLogEntries = processedLogEntries.map(function (entry) {
                var message = undefined;

                if (entry.type === LogType.time) {
                  message = "".concat(entry.args[0], ": ").concat(entry.args[1] * 1000 + entry.args[2] / 1000000, "ms");
                } else if (entry.args && entry.args.length > 0) {
                  message = util.format.apply(util, [entry.args[0]].concat(_toConsumableArray(entry.args.slice(1))));
                }

                return {
                  type: (debugMode || collapsedGroups) && entry.type === LogType.groupCollapsed ? LogType.group : entry.type,
                  message: message,
                  trace: showLoggingTrace && entry.trace ? entry.trace : undefined
                };
              });
              var name = identifierUtils.makePathsRelative(context, origin, compilation.cache).replace(/\|/g, " ");

              if (name in obj.logging) {
                var i = 1;

                while ("".concat(name, "#").concat(i) in obj.logging) {
                  i++;
                }

                name = "".concat(name, "#").concat(i);
              }

              obj.logging[name] = {
                entries: processedLogEntries,
                filteredEntries: logEntries.length - processedLogEntries.length,
                debug: debugMode
              };
            };

            for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
              var _ref3;

              _loop2();
            }
          } catch (err) {
            _iterator14.e(err);
          } finally {
            _iterator14.f();
          }
        })();
      }

      if (showChildren) {
        obj.children = compilation.children.map(function (child, idx) {
          var childOptions = Stats.getChildOptions(options, idx);
          var obj = new Stats(child).toJson(childOptions, forToString);
          delete obj.hash;
          delete obj.version;

          if (child.name) {
            obj.name = identifierUtils.makePathsRelative(context, child.name, compilation.cache);
          }

          return obj;
        });
      }

      return obj;
    }
  }, {
    key: "toString",
    value: function toString(options) {
      if (typeof options === "boolean" || typeof options === "string") {
        options = Stats.presetToOptions(options);
      } else if (!options) {
        options = {};
      }

      var useColors = optionsOrFallback(options.colors, false);
      var obj = this.toJson(options, true);
      return Stats.jsonToString(obj, useColors);
    }
  }], [{
    key: "filterWarnings",
    value: function filterWarnings(warnings, warningsFilter) {
      // we dont have anything to filter so all warnings can be shown
      if (!warningsFilter) {
        return warnings;
      } // create a chain of filters
      // if they return "true" a warning should be suppressed


      var normalizedWarningsFilters = [].concat(warningsFilter).map(function (filter) {
        if (typeof filter === "string") {
          return function (warning) {
            return warning.includes(filter);
          };
        }

        if (filter instanceof RegExp) {
          return function (warning) {
            return filter.test(warning);
          };
        }

        if (typeof filter === "function") {
          return filter;
        }

        throw new Error("Can only filter warnings with Strings or RegExps. (Given: ".concat(filter, ")"));
      });
      return warnings.filter(function (warning) {
        return !normalizedWarningsFilters.some(function (check) {
          return check(warning);
        });
      });
    }
  }, {
    key: "jsonToString",
    value: function jsonToString(obj, useColors) {
      var buf = [];
      var defaultColors = {
        bold: "\x1B[1m",
        yellow: "\x1B[1m\x1B[33m",
        red: "\x1B[1m\x1B[31m",
        green: "\x1B[1m\x1B[32m",
        cyan: "\x1B[1m\x1B[36m",
        magenta: "\x1B[1m\x1B[35m"
      };
      var colors = Object.keys(defaultColors).reduce(function (obj, color) {
        obj[color] = function (str) {
          if (useColors) {
            buf.push(useColors === true || useColors[color] === undefined ? defaultColors[color] : useColors[color]);
          }

          buf.push(str);

          if (useColors) {
            buf.push("\x1B[39m\x1B[22m");
          }
        };

        return obj;
      }, {
        normal: function normal(str) {
          return buf.push(str);
        }
      });

      var coloredTime = function coloredTime(time) {
        var times = [800, 400, 200, 100];

        if (obj.time) {
          times = [obj.time / 2, obj.time / 4, obj.time / 8, obj.time / 16];
        }

        if (time < times[3]) colors.normal("".concat(time, "ms"));else if (time < times[2]) colors.bold("".concat(time, "ms"));else if (time < times[1]) colors.green("".concat(time, "ms"));else if (time < times[0]) colors.yellow("".concat(time, "ms"));else colors.red("".concat(time, "ms"));
      };

      var newline = function newline() {
        return buf.push("\n");
      };

      var getText = function getText(arr, row, col) {
        return arr[row][col].value;
      };

      var table = function table(array, align, splitter) {
        var rows = array.length;
        var cols = array[0].length;
        var colSizes = new Array(cols);

        for (var col = 0; col < cols; col++) {
          colSizes[col] = 0;
        }

        for (var row = 0; row < rows; row++) {
          for (var _col = 0; _col < cols; _col++) {
            var value = "".concat(getText(array, row, _col));

            if (value.length > colSizes[_col]) {
              colSizes[_col] = value.length;
            }
          }
        }

        for (var _row = 0; _row < rows; _row++) {
          for (var _col2 = 0; _col2 < cols; _col2++) {
            var format = array[_row][_col2].color;

            var _value = "".concat(getText(array, _row, _col2));

            var l = _value.length;

            if (align[_col2] === "l") {
              format(_value);
            }

            for (; l < colSizes[_col2] && _col2 !== cols - 1; l++) {
              colors.normal(" ");
            }

            if (align[_col2] === "r") {
              format(_value);
            }

            if (_col2 + 1 < cols && colSizes[_col2] !== 0) {
              colors.normal(splitter || "  ");
            }
          }

          newline();
        }
      };

      var getAssetColor = function getAssetColor(asset, defaultColor) {
        if (asset.isOverSizeLimit) {
          return colors.yellow;
        }

        return defaultColor;
      };

      if (obj.hash) {
        colors.normal("Hash: ");
        colors.bold(obj.hash);
        newline();
      }

      if (obj.version) {
        colors.normal("Version: webpack ");
        colors.bold(obj.version);
        newline();
      }

      if (typeof obj.time === "number") {
        colors.normal("Time: ");
        colors.bold(obj.time);
        colors.normal("ms");
        newline();
      }

      if (typeof obj.builtAt === "number") {
        var builtAtDate = new Date(obj.builtAt);
        var timeZone = undefined;

        try {
          builtAtDate.toLocaleTimeString();
        } catch (err) {
          // Force UTC if runtime timezone is unsupported
          timeZone = "UTC";
        }

        colors.normal("Built at: ");
        colors.normal(builtAtDate.toLocaleDateString(undefined, {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          timeZone: timeZone
        }));
        colors.normal(" ");
        colors.bold(builtAtDate.toLocaleTimeString(undefined, {
          timeZone: timeZone
        }));
        newline();
      }

      if (obj.env) {
        colors.normal("Environment (--env): ");
        colors.bold(JSON.stringify(obj.env, null, 2));
        newline();
      }

      if (obj.publicPath) {
        colors.normal("PublicPath: ");
        colors.bold(obj.publicPath);
        newline();
      }

      if (obj.assets && obj.assets.length > 0) {
        var t = [[{
          value: "Asset",
          color: colors.bold
        }, {
          value: "Size",
          color: colors.bold
        }, {
          value: "Chunks",
          color: colors.bold
        }, {
          value: "",
          color: colors.bold
        }, {
          value: "",
          color: colors.bold
        }, {
          value: "Chunk Names",
          color: colors.bold
        }]];

        var _iterator15 = _createForOfIteratorHelper(obj.assets),
            _step15;

        try {
          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
            var asset = _step15.value;
            t.push([{
              value: asset.name,
              color: getAssetColor(asset, colors.green)
            }, {
              value: SizeFormatHelpers.formatSize(asset.size),
              color: getAssetColor(asset, colors.normal)
            }, {
              value: asset.chunks.join(", "),
              color: colors.bold
            }, {
              value: [asset.emitted && "[emitted]", asset.info.immutable && "[immutable]", asset.info.development && "[dev]", asset.info.hotModuleReplacement && "[hmr]"].filter(Boolean).join(" "),
              color: colors.green
            }, {
              value: asset.isOverSizeLimit ? "[big]" : "",
              color: getAssetColor(asset, colors.normal)
            }, {
              value: asset.chunkNames.join(", "),
              color: colors.normal
            }]);
          }
        } catch (err) {
          _iterator15.e(err);
        } finally {
          _iterator15.f();
        }

        table(t, "rrrlll");
      }

      if (obj.filteredAssets > 0) {
        colors.normal(" ");
        if (obj.assets.length > 0) colors.normal("+ ");
        colors.normal(obj.filteredAssets);
        if (obj.assets.length > 0) colors.normal(" hidden");
        colors.normal(obj.filteredAssets !== 1 ? " assets" : " asset");
        newline();
      }

      var processChunkGroups = function processChunkGroups(namedGroups, prefix) {
        for (var _i2 = 0, _Object$keys = Object.keys(namedGroups); _i2 < _Object$keys.length; _i2++) {
          var name = _Object$keys[_i2];
          var cg = namedGroups[name];
          colors.normal("".concat(prefix, " "));
          colors.bold(name);

          if (cg.isOverSizeLimit) {
            colors.normal(" ");
            colors.yellow("[big]");
          }

          colors.normal(" =");

          var _iterator16 = _createForOfIteratorHelper(cg.assets),
              _step16;

          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var _asset3 = _step16.value;
              colors.normal(" ");
              colors.green(_asset3);
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }

          for (var _i3 = 0, _Object$keys2 = Object.keys(cg.childAssets); _i3 < _Object$keys2.length; _i3++) {
            var _name = _Object$keys2[_i3];
            var assets = cg.childAssets[_name];

            if (assets && assets.length > 0) {
              colors.normal(" ");
              colors.magenta("(".concat(_name, ":"));

              var _iterator17 = _createForOfIteratorHelper(assets),
                  _step17;

              try {
                for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                  var _asset2 = _step17.value;
                  colors.normal(" ");
                  colors.green(_asset2);
                }
              } catch (err) {
                _iterator17.e(err);
              } finally {
                _iterator17.f();
              }

              colors.magenta(")");
            }
          }

          newline();
        }
      };

      if (obj.entrypoints) {
        processChunkGroups(obj.entrypoints, "Entrypoint");
      }

      if (obj.namedChunkGroups) {
        var outputChunkGroups = obj.namedChunkGroups;

        if (obj.entrypoints) {
          outputChunkGroups = Object.keys(outputChunkGroups).filter(function (name) {
            return !obj.entrypoints[name];
          }).reduce(function (result, name) {
            result[name] = obj.namedChunkGroups[name];
            return result;
          }, {});
        }

        processChunkGroups(outputChunkGroups, "Chunk Group");
      }

      var modulesByIdentifier = {};

      if (obj.modules) {
        var _iterator18 = _createForOfIteratorHelper(obj.modules),
            _step18;

        try {
          for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
            var _module = _step18.value;
            modulesByIdentifier["$".concat(_module.identifier)] = _module;
          }
        } catch (err) {
          _iterator18.e(err);
        } finally {
          _iterator18.f();
        }
      } else if (obj.chunks) {
        var _iterator19 = _createForOfIteratorHelper(obj.chunks),
            _step19;

        try {
          for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
            var chunk = _step19.value;

            if (chunk.modules) {
              var _iterator20 = _createForOfIteratorHelper(chunk.modules),
                  _step20;

              try {
                for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                  var _module2 = _step20.value;
                  modulesByIdentifier["$".concat(_module2.identifier)] = _module2;
                }
              } catch (err) {
                _iterator20.e(err);
              } finally {
                _iterator20.f();
              }
            }
          }
        } catch (err) {
          _iterator19.e(err);
        } finally {
          _iterator19.f();
        }
      }

      var processModuleAttributes = function processModuleAttributes(module) {
        colors.normal(" ");
        colors.normal(SizeFormatHelpers.formatSize(module.size));

        if (module.chunks) {
          var _iterator21 = _createForOfIteratorHelper(module.chunks),
              _step21;

          try {
            for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
              var _chunk4 = _step21.value;
              colors.normal(" {");
              colors.yellow(_chunk4);
              colors.normal("}");
            }
          } catch (err) {
            _iterator21.e(err);
          } finally {
            _iterator21.f();
          }
        }

        if (typeof module.depth === "number") {
          colors.normal(" [depth ".concat(module.depth, "]"));
        }

        if (module.cacheable === false) {
          colors.red(" [not cacheable]");
        }

        if (module.optional) {
          colors.yellow(" [optional]");
        }

        if (module.built) {
          colors.green(" [built]");
        }

        if (module.assets && module.assets.length) {
          colors.magenta(" [".concat(module.assets.length, " asset").concat(module.assets.length === 1 ? "" : "s", "]"));
        }

        if (module.prefetched) {
          colors.magenta(" [prefetched]");
        }

        if (module.failed) colors.red(" [failed]");

        if (module.warnings) {
          colors.yellow(" [".concat(module.warnings, " warning").concat(module.warnings === 1 ? "" : "s", "]"));
        }

        if (module.errors) {
          colors.red(" [".concat(module.errors, " error").concat(module.errors === 1 ? "" : "s", "]"));
        }
      };

      var processModuleContent = function processModuleContent(module, prefix) {
        if (Array.isArray(module.providedExports)) {
          colors.normal(prefix);

          if (module.providedExports.length === 0) {
            colors.cyan("[no exports]");
          } else {
            colors.cyan("[exports: ".concat(module.providedExports.join(", "), "]"));
          }

          newline();
        }

        if (module.usedExports !== undefined) {
          if (module.usedExports !== true) {
            colors.normal(prefix);

            if (module.usedExports === null) {
              colors.cyan("[used exports unknown]");
            } else if (module.usedExports === false) {
              colors.cyan("[no exports used]");
            } else if (Array.isArray(module.usedExports) && module.usedExports.length === 0) {
              colors.cyan("[no exports used]");
            } else if (Array.isArray(module.usedExports)) {
              var providedExportsCount = Array.isArray(module.providedExports) ? module.providedExports.length : null;

              if (providedExportsCount !== null && providedExportsCount === module.usedExports.length) {
                colors.cyan("[all exports used]");
              } else {
                colors.cyan("[only some exports used: ".concat(module.usedExports.join(", "), "]"));
              }
            }

            newline();
          }
        }

        if (Array.isArray(module.optimizationBailout)) {
          var _iterator22 = _createForOfIteratorHelper(module.optimizationBailout),
              _step22;

          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var item = _step22.value;
              colors.normal(prefix);
              colors.yellow(item);
              newline();
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }
        }

        if (module.reasons) {
          var _iterator23 = _createForOfIteratorHelper(module.reasons),
              _step23;

          try {
            for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
              var reason = _step23.value;
              colors.normal(prefix);

              if (reason.type) {
                colors.normal(reason.type);
                colors.normal(" ");
              }

              if (reason.userRequest) {
                colors.cyan(reason.userRequest);
                colors.normal(" ");
              }

              if (reason.moduleId !== null) {
                colors.normal("[");
                colors.normal(reason.moduleId);
                colors.normal("]");
              }

              if (reason.module && reason.module !== reason.moduleId) {
                colors.normal(" ");
                colors.magenta(reason.module);
              }

              if (reason.loc) {
                colors.normal(" ");
                colors.normal(reason.loc);
              }

              if (reason.explanation) {
                colors.normal(" ");
                colors.cyan(reason.explanation);
              }

              newline();
            }
          } catch (err) {
            _iterator23.e(err);
          } finally {
            _iterator23.f();
          }
        }

        if (module.profile) {
          colors.normal(prefix);
          var sum = 0;

          if (module.issuerPath) {
            var _iterator24 = _createForOfIteratorHelper(module.issuerPath),
                _step24;

            try {
              for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
                var m = _step24.value;
                colors.normal("[");
                colors.normal(m.id);
                colors.normal("] ");

                if (m.profile) {
                  var time = (m.profile.factory || 0) + (m.profile.building || 0);
                  coloredTime(time);
                  sum += time;
                  colors.normal(" ");
                }

                colors.normal("-> ");
              }
            } catch (err) {
              _iterator24.e(err);
            } finally {
              _iterator24.f();
            }
          }

          for (var _i4 = 0, _Object$keys3 = Object.keys(module.profile); _i4 < _Object$keys3.length; _i4++) {
            var key = _Object$keys3[_i4];
            colors.normal("".concat(key, ":"));
            var _time = module.profile[key];
            coloredTime(_time);
            colors.normal(" ");
            sum += _time;
          }

          colors.normal("= ");
          coloredTime(sum);
          newline();
        }

        if (module.modules) {
          processModulesList(module, prefix + "| ");
        }
      };

      var processModulesList = function processModulesList(obj, prefix) {
        if (obj.modules) {
          var maxModuleId = 0;

          var _iterator25 = _createForOfIteratorHelper(obj.modules),
              _step25;

          try {
            for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
              var _module3 = _step25.value;

              if (typeof _module3.id === "number") {
                if (maxModuleId < _module3.id) maxModuleId = _module3.id;
              }
            }
          } catch (err) {
            _iterator25.e(err);
          } finally {
            _iterator25.f();
          }

          var contentPrefix = prefix + "    ";
          if (maxModuleId >= 10) contentPrefix += " ";
          if (maxModuleId >= 100) contentPrefix += " ";
          if (maxModuleId >= 1000) contentPrefix += " ";

          var _iterator26 = _createForOfIteratorHelper(obj.modules),
              _step26;

          try {
            for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
              var _module4 = _step26.value;
              colors.normal(prefix);
              var name = _module4.name || _module4.identifier;

              if (typeof _module4.id === "string" || typeof _module4.id === "number") {
                if (typeof _module4.id === "number") {
                  if (_module4.id < 1000 && maxModuleId >= 1000) colors.normal(" ");
                  if (_module4.id < 100 && maxModuleId >= 100) colors.normal(" ");
                  if (_module4.id < 10 && maxModuleId >= 10) colors.normal(" ");
                } else {
                  if (maxModuleId >= 1000) colors.normal(" ");
                  if (maxModuleId >= 100) colors.normal(" ");
                  if (maxModuleId >= 10) colors.normal(" ");
                }

                if (name !== _module4.id) {
                  colors.normal("[");
                  colors.normal(_module4.id);
                  colors.normal("]");
                  colors.normal(" ");
                } else {
                  colors.normal("[");
                  colors.bold(_module4.id);
                  colors.normal("]");
                }
              }

              if (name !== _module4.id) {
                colors.bold(name);
              }

              processModuleAttributes(_module4);
              newline();
              processModuleContent(_module4, contentPrefix);
            }
          } catch (err) {
            _iterator26.e(err);
          } finally {
            _iterator26.f();
          }

          if (obj.filteredModules > 0) {
            colors.normal(prefix);
            colors.normal("   ");
            if (obj.modules.length > 0) colors.normal(" + ");
            colors.normal(obj.filteredModules);
            if (obj.modules.length > 0) colors.normal(" hidden");
            colors.normal(obj.filteredModules !== 1 ? " modules" : " module");
            newline();
          }
        }
      };

      if (obj.chunks) {
        var _iterator27 = _createForOfIteratorHelper(obj.chunks),
            _step27;

        try {
          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            var _chunk5 = _step27.value;
            colors.normal("chunk ");
            if (_chunk5.id < 1000) colors.normal(" ");
            if (_chunk5.id < 100) colors.normal(" ");
            if (_chunk5.id < 10) colors.normal(" ");
            colors.normal("{");
            colors.yellow(_chunk5.id);
            colors.normal("} ");
            colors.green(_chunk5.files.join(", "));

            if (_chunk5.names && _chunk5.names.length > 0) {
              colors.normal(" (");
              colors.normal(_chunk5.names.join(", "));
              colors.normal(")");
            }

            colors.normal(" ");
            colors.normal(SizeFormatHelpers.formatSize(_chunk5.size));

            var _iterator28 = _createForOfIteratorHelper(_chunk5.parents),
                _step28;

            try {
              for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
                var _id = _step28.value;
                colors.normal(" <{");
                colors.yellow(_id);
                colors.normal("}>");
              }
            } catch (err) {
              _iterator28.e(err);
            } finally {
              _iterator28.f();
            }

            var _iterator29 = _createForOfIteratorHelper(_chunk5.siblings),
                _step29;

            try {
              for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
                var _id2 = _step29.value;
                colors.normal(" ={");
                colors.yellow(_id2);
                colors.normal("}=");
              }
            } catch (err) {
              _iterator29.e(err);
            } finally {
              _iterator29.f();
            }

            var _iterator30 = _createForOfIteratorHelper(_chunk5.children),
                _step30;

            try {
              for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
                var _id3 = _step30.value;
                colors.normal(" >{");
                colors.yellow(_id3);
                colors.normal("}<");
              }
            } catch (err) {
              _iterator30.e(err);
            } finally {
              _iterator30.f();
            }

            if (_chunk5.childrenByOrder) {
              for (var _i5 = 0, _Object$keys4 = Object.keys(_chunk5.childrenByOrder); _i5 < _Object$keys4.length; _i5++) {
                var name = _Object$keys4[_i5];
                var children = _chunk5.childrenByOrder[name];
                colors.normal(" ");
                colors.magenta("(".concat(name, ":"));

                var _iterator31 = _createForOfIteratorHelper(children),
                    _step31;

                try {
                  for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
                    var id = _step31.value;
                    colors.normal(" {");
                    colors.yellow(id);
                    colors.normal("}");
                  }
                } catch (err) {
                  _iterator31.e(err);
                } finally {
                  _iterator31.f();
                }

                colors.magenta(")");
              }
            }

            if (_chunk5.entry) {
              colors.yellow(" [entry]");
            } else if (_chunk5.initial) {
              colors.yellow(" [initial]");
            }

            if (_chunk5.rendered) {
              colors.green(" [rendered]");
            }

            if (_chunk5.recorded) {
              colors.green(" [recorded]");
            }

            if (_chunk5.reason) {
              colors.yellow(" ".concat(_chunk5.reason));
            }

            newline();

            if (_chunk5.origins) {
              var _iterator32 = _createForOfIteratorHelper(_chunk5.origins),
                  _step32;

              try {
                for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
                  var origin = _step32.value;
                  colors.normal("    > ");

                  if (origin.reasons && origin.reasons.length) {
                    colors.yellow(origin.reasons.join(" "));
                    colors.normal(" ");
                  }

                  if (origin.request) {
                    colors.normal(origin.request);
                    colors.normal(" ");
                  }

                  if (origin.module) {
                    colors.normal("[");
                    colors.normal(origin.moduleId);
                    colors.normal("] ");
                    var _module5 = modulesByIdentifier["$".concat(origin.module)];

                    if (_module5) {
                      colors.bold(_module5.name);
                      colors.normal(" ");
                    }
                  }

                  if (origin.loc) {
                    colors.normal(origin.loc);
                  }

                  newline();
                }
              } catch (err) {
                _iterator32.e(err);
              } finally {
                _iterator32.f();
              }
            }

            processModulesList(_chunk5, " ");
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
      }

      processModulesList(obj, "");

      if (obj.logging) {
        for (var _i6 = 0, _Object$keys5 = Object.keys(obj.logging); _i6 < _Object$keys5.length; _i6++) {
          var _origin = _Object$keys5[_i6];
          var logData = obj.logging[_origin];

          if (logData.entries.length > 0) {
            newline();

            if (logData.debug) {
              colors.red("DEBUG ");
            }

            colors.bold("LOG from " + _origin);
            newline();
            var indent = "";

            var _iterator33 = _createForOfIteratorHelper(logData.entries),
                _step33;

            try {
              for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
                var entry = _step33.value;
                var color = colors.normal;
                var prefix = "    ";

                switch (entry.type) {
                  case LogType.clear:
                    colors.normal("".concat(indent, "-------"));
                    newline();
                    continue;

                  case LogType.error:
                    color = colors.red;
                    prefix = "<e> ";
                    break;

                  case LogType.warn:
                    color = colors.yellow;
                    prefix = "<w> ";
                    break;

                  case LogType.info:
                    color = colors.green;
                    prefix = "<i> ";
                    break;

                  case LogType.log:
                    color = colors.bold;
                    break;

                  case LogType.trace:
                  case LogType.debug:
                    color = colors.normal;
                    break;

                  case LogType.status:
                    color = colors.magenta;
                    prefix = "<s> ";
                    break;

                  case LogType.profile:
                    color = colors.magenta;
                    prefix = "<p> ";
                    break;

                  case LogType.profileEnd:
                    color = colors.magenta;
                    prefix = "</p> ";
                    break;

                  case LogType.time:
                    color = colors.magenta;
                    prefix = "<t> ";
                    break;

                  case LogType.group:
                    color = colors.cyan;
                    prefix = "<-> ";
                    break;

                  case LogType.groupCollapsed:
                    color = colors.cyan;
                    prefix = "<+> ";
                    break;

                  case LogType.groupEnd:
                    if (indent.length >= 2) indent = indent.slice(0, indent.length - 2);
                    continue;
                }

                if (entry.message) {
                  var _iterator34 = _createForOfIteratorHelper(entry.message.split("\n")),
                      _step34;

                  try {
                    for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
                      var line = _step34.value;
                      colors.normal("".concat(indent).concat(prefix));
                      color(line);
                      newline();
                    }
                  } catch (err) {
                    _iterator34.e(err);
                  } finally {
                    _iterator34.f();
                  }
                }

                if (entry.trace) {
                  var _iterator35 = _createForOfIteratorHelper(entry.trace),
                      _step35;

                  try {
                    for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
                      var _line = _step35.value;
                      colors.normal("".concat(indent, "| ").concat(_line));
                      newline();
                    }
                  } catch (err) {
                    _iterator35.e(err);
                  } finally {
                    _iterator35.f();
                  }
                }

                switch (entry.type) {
                  case LogType.group:
                    indent += "  ";
                    break;
                }
              }
            } catch (err) {
              _iterator33.e(err);
            } finally {
              _iterator33.f();
            }

            if (logData.filteredEntries) {
              colors.normal("+ ".concat(logData.filteredEntries, " hidden lines"));
              newline();
            }
          }
        }
      }

      if (obj._showWarnings && obj.warnings) {
        var _iterator36 = _createForOfIteratorHelper(obj.warnings),
            _step36;

        try {
          for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
            var warning = _step36.value;
            newline();
            colors.yellow("WARNING in ".concat(warning));
            newline();
          }
        } catch (err) {
          _iterator36.e(err);
        } finally {
          _iterator36.f();
        }
      }

      if (obj._showErrors && obj.errors) {
        var _iterator37 = _createForOfIteratorHelper(obj.errors),
            _step37;

        try {
          for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
            var error = _step37.value;
            newline();
            colors.red("ERROR in ".concat(error));
            newline();
          }
        } catch (err) {
          _iterator37.e(err);
        } finally {
          _iterator37.f();
        }
      }

      if (obj.children) {
        var _iterator38 = _createForOfIteratorHelper(obj.children),
            _step38;

        try {
          for (_iterator38.s(); !(_step38 = _iterator38.n()).done;) {
            var child = _step38.value;
            var childString = Stats.jsonToString(child, useColors);

            if (childString) {
              if (child.name) {
                colors.normal("Child ");
                colors.bold(child.name);
                colors.normal(":");
              } else {
                colors.normal("Child");
              }

              newline();
              buf.push("    ");
              buf.push(childString.replace(/\n/g, "\n    "));
              newline();
            }
          }
        } catch (err) {
          _iterator38.e(err);
        } finally {
          _iterator38.f();
        }
      }

      if (obj.needAdditionalPass) {
        colors.yellow("Compilation needs an additional pass and will compile again.");
      }

      while (buf[buf.length - 1] === "\n") {
        buf.pop();
      }

      return buf.join("");
    }
  }, {
    key: "presetToOptions",
    value: function presetToOptions(name) {
      // Accepted values: none, errors-only, minimal, normal, detailed, verbose
      // Any other falsy value will behave as 'none', truthy values as 'normal'
      var pn = typeof name === "string" && name.toLowerCase() || name || "none";

      switch (pn) {
        case "none":
          return {
            all: false
          };

        case "verbose":
          return {
            entrypoints: true,
            chunkGroups: true,
            modules: false,
            chunks: true,
            chunkModules: true,
            chunkOrigins: true,
            depth: true,
            env: true,
            reasons: true,
            usedExports: true,
            providedExports: true,
            optimizationBailout: true,
            errorDetails: true,
            publicPath: true,
            logging: "verbose",
            exclude: false,
            maxModules: Infinity
          };

        case "detailed":
          return {
            entrypoints: true,
            chunkGroups: true,
            chunks: true,
            chunkModules: false,
            chunkOrigins: true,
            depth: true,
            usedExports: true,
            providedExports: true,
            optimizationBailout: true,
            errorDetails: true,
            publicPath: true,
            logging: true,
            exclude: false,
            maxModules: Infinity
          };

        case "minimal":
          return {
            all: false,
            modules: true,
            maxModules: 0,
            errors: true,
            warnings: true,
            logging: "warn"
          };

        case "errors-only":
          return {
            all: false,
            errors: true,
            moduleTrace: true,
            logging: "error"
          };

        case "errors-warnings":
          return {
            all: false,
            errors: true,
            warnings: true,
            logging: "warn"
          };

        default:
          return {};
      }
    }
  }, {
    key: "getChildOptions",
    value: function getChildOptions(options, idx) {
      var innerOptions;

      if (Array.isArray(options.children)) {
        if (idx < options.children.length) {
          innerOptions = options.children[idx];
        }
      } else if (_typeof(options.children) === "object" && options.children) {
        innerOptions = options.children;
      }

      if (typeof innerOptions === "boolean" || typeof innerOptions === "string") {
        innerOptions = Stats.presetToOptions(innerOptions);
      }

      if (!innerOptions) {
        return options;
      }

      var childOptions = Object.assign({}, options);
      delete childOptions.children; // do not inherit children

      return Object.assign(childOptions, innerOptions);
    }
  }]);

  return Stats;
}();

module.exports = Stats;